import { openModal } from 'store/modals/actions';

import { useCancelSubscription, useDispatch, useGetCancellationReasonModal, useModals } from 'hooks';
import CancellationReasonModal from 'modals/CancellationReasonModal';

const CancellationReasonModalContainer = () => {
    const dispatch = useDispatch();
    const { closeModal } = useModals();

    const { discardCancellation, onCancelSubscription } = useCancelSubscription();
    const { getCancellationReasonModal } = useGetCancellationReasonModal();

    const onSubmit = async (reason: string) => {
        const modalName = await getCancellationReasonModal(reason);

        dispatch(openModal(modalName, { onError: onCancelSubscription }));
    };

    const handleClose = () => {
        closeModal();
        discardCancellation();
    };

    return <CancellationReasonModal onSubmit={onSubmit} onClose={handleClose} onCancel={onCancelSubscription} />;
};

export default CancellationReasonModalContainer;
